import * as ko from 'knockout';
import videojs from 'video.js';

import 'video.js/dist/video-js.css';

var videoplayer;

ko.bindingHandlers.videojs = 
{
    init: function(element, valueAccessor, allBindingsAccessor) 
    {
        var videoSource = ko.utils.unwrapObservable(valueAccessor()),
            playerId = allBindingsAccessor().playerId,
            multiple_videos = allBindingsAccessor().multiple_videos,
            preload = allBindingsAccessor().preload,
            autoplay = allBindingsAccessor().autoplay,
            muted = allBindingsAccessor().muted,
            fullscreen = allBindingsAccessor().fullscreen;

        if( !preload )
            preload = 'none';

        if( autoplay !== false && autoplay !== true )
            autoplay = false;

        if( muted !== false && muted !== true )
            muted = false;

        if( fullscreen !== false && fullscreen !== true )
            fullscreen = false;

        var options = {
            controls: true,
            muted: muted,
            autoplay: autoplay,
            preload: preload,
            controlBar: {
                fullscreenToggle: fullscreen,
            },
        };

        if( videoSource ) 
        {
            // If videoplayer was previously initialized, dispose and re-create it
            if( videoplayer && multiple_videos !== true )
                videoplayer.dispose();

            videoplayer = videojs(playerId, options, function()
            {
                this.src(videoSource);

                // Dispose the player after stopping a live stream
                this.tech().on("retryplaylist", (event) => {
                    this.dispose();
                });
            });
        }
    },
    update: function(element, valueAccessor, allBindingsAccessor) 
    {
        var videoSource = ko.utils.unwrapObservable(valueAccessor()),
            playerId = allBindingsAccessor().playerId,
            video = videojs(playerId);

        if( videoSource )
            video.src(videoSource);
    }
};